import { LoadingPage } from '@seddi/ui-kit';
import type { FC } from 'react';

import { decoratorGradient } from '@/styles/theme';
import { AppLoadingPageProps } from './AppLoadingPage.types';

import BackgroundImage from '@/static/images/background_image.webp';
import DecoratorLogo from '@/static/images/seddi_decorator.svg';

export const AppLoadingPage: FC<AppLoadingPageProps> = ({
  message = 'Decorator is loading… please wait',
}) => {
  return (
    <LoadingPage
      backgroundGradient={decoratorGradient}
      backgroundImage={BackgroundImage}
      brandLogo={DecoratorLogo as unknown as string}
      message={message}
      brandName="Decorator"
    />
  );
};
